<template>
	<!-- Begin Page Content -->
        <div class="container-fluid" v-if="school">
          <div class="row justify-content-between">
            <div class="col text-center">
              <h3 class="h3 mb-2 text-gray-800">Сургуулийн заах хичээлүүд</h3>
              <h5 class="h5 mb-2 text-gray-800">{{school.name}}</h5>
            </div>
            
          </div>
          <!-- Page Heading -->

		 
          <!-- DataTales Example -->
          <div class="card shadow my-4" v-for="(semester) in semesters" v-bind:key="semester.id">
            <div class="card-header row m-0">
              <div class="col">
                <h4>{{semester.title}}</h4>
              </div>
              <!-- <div v-if='semester.default==true' class="col-auto">
                <div class="btn btn-success btn-sm" @click="$router.push({ name: 'ILessonAdd', params:{ 'schoolId': schoolId, semesterId: semester.id, setTeacher: true } })">Хичээл нэмэх</div>

              </div> -->

            </div>
            <div class="card-body">
              <div class="table-responsive">
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0" v-if="semester.lessons!=null && semester.lessons.length>0">
                  <thead>
                    <tr>
                      <th>№</th>
                      <th style="width: 28%">Нэр</th>
                      <th>Xичээлийн код</th>
                      <th>Мэдээлэл</th>
                      <th>Заах багш</th>
                      <th>Төлөв</th>
                      <th>Үйлдэл</th>
                    </tr>
                  </thead>

                  <tbody>
					          <tr v-for="(lesson, index) in semester.lessons" v-bind:key="lesson.id">
                      <td>{{index+1}}</td>
                      <td>{{lesson.name}}</td>
                      <td>{{lesson.lectureCode}}</td>
                      <td>
                        <div v-if="lesson.numberOfStudents">Оюутан: {{lesson.numberOfStudents}}</div>
                        <div v-else title="Та оюутан нэмээгүй байна.Оюутнууд энэ хичээлийг үзэж чадахгүй.">
                          <i class="text-danger fas fa-exclamation-triangle mr-2"></i>
                          <span class="text-danger">оюутан нэмээгүй</span>
                        </div>
                        <div v-if="lesson.numberOfTopics">Сэдэв: {{lesson.numberOfTopics}}</div>
                        <div v-if="lesson.numberOfVideos">Видео хичээл: {{lesson.numberOfVideos}}</div>
                        <div v-else >
                          <i class="text-warning fas fa-exclamation-triangle mr-2"></i>
                          <span class="text-danger">видео ороогүй</span>
                        </div>
                      </td>
                      <td>
                        <div v-if="lesson.teachedBy">
                          <span v-if="lesson.teachedBy.name">
                            {{lesson.teachedBy.name}}
                            <br/>
                          </span>
                          <span v-if="lesson.teachedBy.code">
                            {{lesson.teachedBy.code}}
                            <br/>
                          </span>
                          <span v-if="lesson.teachedBy.email">
                            {{lesson.teachedBy.email}}
                          </span>
                        </div>

                      </td>
                      <td>
                        <h6 v-if="lesson.published==true" style="cursor:pointer"><span class="badge badge-success">Нээлттэй</span></h6>
                        <h6 v-else style="cursor:pointer"><span class="badge badge-danger" >Хаалттай</span></h6>
                      </td>
                      <td>
                        <div class="row">
                          <button class="btn  btn-outline-primary btn-sm mx-1" @click="goDetail(lesson)">хараx</button>
                          <button class="btn btn-warning btn-sm mx-1" @click="edit(lesson)">засах</button>
                          <!-- <div class="btn btn-danger btn-sm mx-1" @click="askCopyLesson(lesson)">Copy</div> -->
                          <button class="btn  btn-outline-success btn-sm mx-1" @click="$router.push({ name: 'LessonStudent', params: { lessonId: lesson.id, schoolId: schoolId} })" >оюутан</button>
                          
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div v-else class="alert alert-info text-center">Та {{semester.title}} семестерт ямар нэгэн хичээл оруулаагүй байна.</div>
                <hr class="my-3"/>
                <table class="table table-bordered" id="dataTable" width="100%" cellspacing="0" v-if="semester.addlessons!=null && semester.addlessons.length>0">
                  <thead>
                    <tr>
                      <th>№</th>
                      <th style="width: 28%">Нэр</th>
                      <th>Xичээлийн код</th>
                      <th>Мэдээлэл</th>
                      <th>Заах багш</th>
                      <th>Төлөв</th>
                      <th>Үйлдэл</th>
                    </tr>
                  </thead>

                  <tbody>
					          <tr v-for="(lesson, index) in semester.addlessons" v-bind:key="lesson.id">
                      <td>{{index+1}}</td>
                      <td>{{lesson.name}}</td>
                      <td>{{lesson.lectureCode}}</td>
                      <td>
                        <div v-if="lesson.numberOfStudents">Оюутан: {{lesson.numberOfStudents}}</div>
                        <div v-else title="Та оюутан нэмээгүй байна.Оюутнууд энэ хичээлийг үзэж чадахгүй.">
                          <i class="text-danger fas fa-exclamation-triangle mr-2"></i>
                          <span class="text-danger">оюутан нэмээгүй</span>
                        </div>
                        <div v-if="lesson.numberOfTopics">Сэдэв: {{lesson.numberOfTopics}}</div>
                        <div v-if="lesson.numberOfVideos">Видео хичээл: {{lesson.numberOfVideos}}</div>
                        <div v-else >
                          <i class="text-warning fas fa-exclamation-triangle mr-2"></i>
                          <span class="text-danger">видео ороогүй</span>
                        </div>
                      </td>
                      <td>
                        <div v-if="lesson.teachedBy">
                          <span v-if="lesson.teachedBy.name">
                            {{lesson.teachedBy.name}}
                            <br/>
                          </span>
                          <span v-if="lesson.teachedBy.code">
                            {{lesson.teachedBy.code}}
                            <br/>
                          </span>
                          <span v-if="lesson.teachedBy.email">
                            {{lesson.teachedBy.email}}
                          </span>
                        </div>

                      </td>
                      <td>
                        <h6 v-if="lesson.published==true" style="cursor:pointer"><span class="badge badge-success">Нээлттэй</span></h6>
                        <h6 v-else style="cursor:pointer"><span class="badge badge-danger" >Хаалттай</span></h6>
                      </td>
                      <td>
                        <div class="row">
                          <button class="btn  btn-outline-primary btn-sm mx-1" @click="goDetail(lesson)">хараx</button>
                          <button class="btn btn-warning btn-sm mx-1" @click="edit(lesson)">засах</button>
                          <!-- <div class="btn btn-danger btn-sm mx-1" @click="askCopyLesson(lesson)">Copy</div> -->
                          <button class="btn  btn-outline-success btn-sm mx-1" @click="$router.push({ name: 'LessonStudent', params: { lessonId: lesson.id, schoolId: lesson.school.id} })" >оюутан</button>
                          
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>


           <!-- Modal -->
          <div class="modal fade" id="copyModal" tabindex="-1" role="dialog" aria-labelledby="copyModalLabel" aria-hidden="true">
            <div class="modal-dialog" role="document">
              <div class="modal-content">
                <div class="modal-header">
                  <h5 class="modal-title" id="qaModalLabel">Хичээл хуулах</h5>
                  
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                  </button>
                </div>
                <div class="modal-body" v-if='copyLesson!=null'>
                  <h3>Та {{copyLesson.name}} хичээлийг хуулах уу? Хэрэв хуулах бол доорх хичээлийн улирлуудаас сонгоно уу</h3>
                  <div class="row">
                    <div class="col form-group">
                      <label for="exampleFormControlSelect1">Улирал:</label>
                      <select class="form-control" v-model="copySemester">
                        <option v-for="semester in semesters" v-bind:key="'semester-'+semester.id" v-bind:value="semester.id">{{semester.title}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="modal-footer">
                  <button type="button" class="btn btn-secondary" data-dismiss="modal">Болих</button>
                  <button @click="doCopy" type="button" class="btn btn-primary btn-user btn-block">Хуулах</button>
                </div>
              </div>
            </div>
          </div>

        </div>
        <!-- /.container-fluid -->
</template>

<script>
const fb = require('../../firebaseConfig.js')
import Vue from 'vue'
import { mapState } from "vuex";
import { currentUser } from '../../firebaseConfig.js';
import moment from 'moment'
export default {
  name: "SLessons",
  data() {
    return {
      msg: "Hellow",
      lessons: [],
      trending:{
        content:[]
      },
      semesters:[],
      copyLesson:null,
      copySemester:null,
      school:null
    };
  },
  computed: {
    ...mapState(["currentUser", "userProfile"])
  },
  props:{
    schoolId:{
      required:true
    }
  },
  created() {
    
      this._getLessons();
    
  },
   methods: {
      _getLessons(){
		  var _this = this;
      var vm = this;

      fb.db.collection("schools").doc(this.schoolId).get().then(doc=>{
        if(doc.exists){
          let object=doc.data();
          object.id=doc.id;
          this.school=object;
        }
      });

      fb.db.collection("semester").where("default", "==", true).get().then(semestersSnapshot=>{
        semestersSnapshot.forEach(semesterDoc=> {
            let object=semesterDoc.data()
            object.id = semesterDoc.id;
            object.lessons=[];
            object.addlessons=[];
            fb.db.collection("lessons")
              .where("school", "==", fb.db.collection("schools").doc(this.schoolId))
              .where("semester", "==", semesterDoc.ref)
              .get().then(querySnapshot1=> {
              object.lessons=[];
              querySnapshot1.forEach(lessonDoc=> {
                  let lesson=lessonDoc.data();
                  lesson.id = lessonDoc.id;
                  lesson.teachedBy=null;
                  if(lesson.teacher){
                    lesson.teacher.get().then(tdoc=>{
                      if(tdoc.exists){
                        lesson.teachedBy=tdoc.data();
                      }
                    });
                  }
                  object.lessons.push(lesson);
              });
            });

            fb.db.collection("lessons")
              .where("addschools", "array-contains", fb.db.collection("schools").doc(this.schoolId))
              .where("semester", "==", semesterDoc.ref)
              .get().then(querySnapshot1=> {
              object.addlessons=[];
              querySnapshot1.forEach(lessonDoc=> {
                  let lesson=lessonDoc.data();
                  lesson.id = lessonDoc.id;
                  lesson.teachedBy=null;
                  if(lesson.teacher){
                    lesson.teacher.get().then(tdoc=>{
                      if(tdoc.exists){
                        lesson.teachedBy=tdoc.data();
                      }
                    });
                  }
                  object.addlessons.push(lesson);
              });
            });
					  _this.semesters.push(object);
				});
      });

      
      
    },
    askCopyLesson(lesson){
      var r = confirm("Та "+lesson.name+ " хичээлийг хуулахдаа итгэлтэй байна уу!!!");
      if (r == true) {
        this.copyLesson=lesson;
        $('#copyModal').modal('show');
      } 

    },
    async doCopy(lesson){
      if(this.copyLesson!=null && this.copySemester!=null && this.copySemester!=''){
       

        var copyLessonRef=await fb.db.collection("lessons").doc();
        var tmpLesson = Object.assign({}, this.copyLesson);
        delete tmpLesson.id;
        tmpLesson.createdAt=new Date();
        tmpLesson.lectureCode=new Date().getTime();
        tmpLesson.copiedFrom=fb.db.collection("lessons").doc(this.copyLesson.id);
        tmpLesson.semester=fb.db.collection("semester").doc(this.copySemester);
        tmpLesson.copiedAt=new Date();
        tmpLesson.published=false;

        copyLessonRef.set(tmpLesson);

        var topicDocs=await fb.db.collection('lessons/'+this.copyLesson.id+'/topics').orderBy("createdAt").get();
        
        for (const topic of topicDocs.docs) {
          console.log(topic);
          var tmpTopic = topic.data();
          var copyTopicRef= copyLessonRef.collection("topics").doc();
          copyTopicRef.set(tmpTopic);

          var detailDocs=await fb.db.collection('lessons/'+this.copyLesson.id+'/topics/'+topic.id+"/details").orderBy("createdAt").get();
        
          for (const detail of detailDocs.docs) {
            var tmpdetail = detail.data();
            copyTopicRef.collection("details").doc().set(tmpdetail);

          }

        }

        this.copyLesson=null;
        this.copySemester=null;
        $('#copyModal').modal('hide');
      }
      else{
        alert("Та хуулах хичээл болон улиралаа заавал сонгоно уу");

      }
    },
		
    goDetail(lesson){
      if(this.userProfile && this.userProfile.role && this.userProfile.role=='lesson_manager'){
        this.$router.push({ name: 'LessonDetail', params: { lessonId: lesson.id} });
      }
      // if(lesson.isBlock!=true && (lesson.school==null || lesson.department==null || lesson.program==null)){
      //   alert("Та эхлээд хичээлийнхээ сургууль , тэнхим болон хөтөлбөрийг сонгоно уу");
      //   this.$router.push({ name: 'LessonEdit', params: { lessonId: lesson.id} });
      // }
      else
        this.$router.push({ name: 'LessonDetailAdmin', params: { lessonId: lesson.id} });
    },
    edit(lesson){
      if(lesson.school && lesson.school.id)
          this.$router.push({ name: 'ILessonAdd', params: { schoolId: lesson.school.id ,lessonId: lesson.id, setTeacher:true} });
      else
        this.$router.push({ name: 'ILessonAdd', params: { schoolId: lesson.school.id ,lessonId: schoolId, setTeacher:true} });
    }

	},
	filters: {
		formatDate(val) {
			if (!val) { return '-' }
			let date = val.toDate()
			return moment(date).fromNow()
		},
	
	}
};
</script>